// src/components/PrintableHeatMatrix.js
import React, { useRef } from 'react';
import './PrintableHeatMatrix.css';
import { useReactToPrint } from 'react-to-print';

const PrintableHeatMatrix = ({ event, heats, onClose }) => {
  // Create a ref that we'll attach to the printable content
  const printRef = useRef(null);
  
  // Set up the print handler with the correct ref
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `${event.name} - Heat Distribution`,
    onAfterPrint: onClose
  });

  // Get the list of all dances from heats
  const dances = heats.map(dance => dance.dance);

  return (
    <div className="printable-overlay">
      <div className="printable-container">
        <div className="printable-actions">
          <h2>Heat Distribution</h2>
          <div>
            <button className="print-button" onClick={handlePrint}>
              Print as PDF
            </button>
            <button className="close-button" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
        
        {/* Apply the ref to this div - this is the content that will be printed */}
        <div className="printable-content" ref={printRef}>
          <div className="print-header">
            <h1>{event.name}</h1>
            <h2>{event.roundType} - Heat Distribution</h2>
            <p className="event-details">
              Dances: {event.dances.join(', ')}
              <br />
              Number of Heats: {event.numHeats}
            </p>
          </div>
          
          <div className="dancer-dance-matrix">
    
            <table className="matrix-table">
              <thead>
                <tr>
                  <th>Dancer(s)</th>
                  {dances.map((dance, index) => (
                    <th key={index}>{dance}</th>
                  ))}
                  <th>Total Heats</th>
                </tr>
              </thead>
              <tbody>
                {event.dancers
                  .sort((a, b) => parseInt(a.clothNumber) - parseInt(b.clothNumber))
                  .map((dancer) => {
                    // Calculate which dances this dancer is in
                    const dancerHeats = heats.map((dance) => {
                      const heatNumber = dance.heats.findIndex(heat => 
                        heat.dancers.some(d => d.clothNumber === dancer.clothNumber)
                      );
                      return heatNumber !== -1 ? `Heat ${heatNumber + 1}` : '-';
                    });
                    
                    // Count total heats
                    const totalHeats = dancerHeats.filter(h => h !== '-').length;
                    
                    return (
                      <tr key={dancer.clothNumber}>
                        <td className="dancer-cell">
                          <strong>{dancer.clothNumber}</strong>
                          
                        </td>
                        {dancerHeats.map((heat, index) => (
                          <td key={index} className={heat !== '-' ? 'in-heat' : ''}>
                            {heat}
                          </td>
                        ))}
                        <td>{totalHeats}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          
          <div className="print-footer">
            <p>Printed on: {new Date().toLocaleDateString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintableHeatMatrix;